import { AlertTriangle, Eye } from 'lucide-react';
import type { PublishGateInfo } from '@/lib/types-publish-gate';

/**
 * v0.3 (S-9): データ公開ゲートのバナー。
 * Design H2対応: 「未公開draft閲覧中」はページ最上部sticky、「集計に含まれない店舗」はh1直下カード。
 * 本コンポーネントでは呼び出し元のレイアウトに合わせて両方のケースを1つのバナーに統合する
 * (同一severityのバナー乱立を避ける)。
 */
/** 店舗名の列挙上限。超えた分は件数に畳む (StoreComparisonPage の選択店舗チップと同じ閾値、§8-181系) */
const MAX_NAMES_SHOWN = 5;

export const PublishGateBanner = ({ publishGate }: { publishGate: PublishGateInfo | null | undefined }) => {
  if (!publishGate || (!publishGate.partial_month && !publishGate.viewing_draft)) return null;

  const names = publishGate.excluded_store_names;
  const shownNames = names.slice(0, MAX_NAMES_SHOWN).map((s) => s.node_name).join('、');
  const restCount = names.length - MAX_NAMES_SHOWN;

  return (
    <div className="rounded-lg bg-alert-bg border border-alert-border px-4 py-3 flex items-start gap-2" role="note">
      <AlertTriangle size={16} className="text-alert-text shrink-0 mt-0.5" aria-hidden />
      <div className="text-[13px] text-alert-text space-y-1 min-w-0">
        {publishGate.viewing_draft && (
          <p className="flex items-center gap-1"><Eye size={14} className="shrink-0" aria-hidden /> 未公開データを含めて表示中です (通常の閲覧者には見えません)</p>
        )}
        {publishGate.partial_month && (
          <p>
            {publishGate.total_month_count ? (
              <>この期間は{publishGate.excluded_month_count ?? 0}/{publishGate.total_month_count}ヶ月分が未公開のため、集計から除外されています</>
            ) : (
              <>この期間には未公開の店舗が含まれるため、集計から除外されています</>
            )}
            {names.length > 0 && (
              <span>: {shownNames}{restCount > 0 && <>、ほか{restCount}店舗</>}</span>
            )}
          </p>
        )}
      </div>
    </div>
  );
};
